import { useIntl } from 'react-intl';
import { Typography, Icon } from '@developer/components';

import { TYPOGRAPHY_HEADLINE3 } from '@developer/config';

import { useHiddenAPIAccess } from '@developer/portal/hooks';

import './styles.scss';

export const AppAPIAccess = (): JSX.Element => {
  const {
    clientID,
    secret,
    btnShowClientIDHandler,
    btnShowSecretHandler,
    btnCopySecretHandler,
    btnCopyClientIDHandler,
    isClientIDHidden,
    isSecretHidden,
  } = useHiddenAPIAccess({
    originalClientId: 'ghfjrdwdfgefsacgrtghseerfsqwer',
    originalSecret: 'ghfjrdwdfgefsacgrtghseerfsqwer',
    shouldNotBeDefaultHidden: false,
  });

  const { formatMessage } = useIntl();

  return (
    <div className={'dev-portal__dashboard__app-api-access'}>
      <Typography tag={'h6'} variant={TYPOGRAPHY_HEADLINE3}>
        {formatMessage({id:'developer_portal_app_api_access_title'})}
      </Typography>
      <div className={'dev-portal__dashboard__app-api-access-value-box'}>
        <Typography tag={'p'} variant={TYPOGRAPHY_HEADLINE3}>
          {formatMessage({id:'developer_portal_app_api_access_label_clientid'})}
        </Typography>
        <Typography
          tag={'span'}
          variant={TYPOGRAPHY_HEADLINE3}
          classes={
            isClientIDHidden ? 'span-value-hidden' : 'span-value-visible'
          }
        >
          {clientID}
        </Typography>
        <Icon
          width={24}
          height={24}
          variant={'copy'}
          onClick={btnCopyClientIDHandler}
          isPointer
        />
        <Icon
          width={24}
          height={24}
          variant={'show-eye'}
          onClick={btnShowClientIDHandler}
          isPointer
        />
      </div>
      <div className={'dev-portal__dashboard__app-api-access-value-box'}>
        <Typography tag={'p'} variant={TYPOGRAPHY_HEADLINE3}>
          {formatMessage({id:'developer_portal_app_api_access_label_secret'})}
        </Typography>
        <Typography
          tag={'span'}
          variant={TYPOGRAPHY_HEADLINE3}
          classes={isSecretHidden ? 'span-value-hidden' : 'span-value-visible'}
        >
          {secret}
        </Typography>
        <Icon
          width={24}
          height={24}
          variant={'copy'}
          onClick={btnCopySecretHandler}
          isPointer
        />
        <Icon
          width={24}
          height={24}
          variant={'show-eye'}
          onClick={btnShowSecretHandler}
          isPointer
        />
      </div>
    </div>
  );
};
